// extracted by mini-css-extract-plugin
export default {"wrapper":"D6gsp","content":"QUTRC","nowrap":"q6DGG"};